module.exports = require("./fr-GN.d.ts");